import { call, CallEffect, put, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import moment from "moment";
import { automaticApi } from "@/settings/api";
import { Action } from "redux-saga";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
  period: "30" | "60" | "90";
  callback: (success: boolean, data?: RechargesItems["items"]) => void;
}

export interface RequestRechargesAction {
  type: string;
  payload: Fetch;
}

export interface RechargesItems {
  items:
    | {
        transactionDate: string;
        usageDescription: string;
        vehiclePlate: string;
        value: string;
        eventDate: string;
        releaseDateHistory: string;
        entryValue: string;
      }[]
    | null;
}

const uri = "/financial/v1/statement/realbalance";

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* requestRecharges({
  payload,
}: RequestRechargesAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse<
    {
      status: {
        codigoRetorno: number;
      };
      data: {
        movimentations: {
          transactionDate: string;
          usageDescription: string;
          vehiclePlate: string;
          value: string;
          eventDate: string;
          releaseDateHistory: string;
          entryValue: string;
        };
      }[];
    },
    any
  >
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomerReducer);

    const initialDate = moment()
      .subtract(payload.period, "days")
      .format("YYYY-MM-DD");
    const finalDate = moment().format("YYYY-MM-DD");

    const res = yield call(automaticApi.get, uri, {
      params: {
        startDate: initialDate,
        endDate: finalDate,
        onlyRecharge: true,
        pageNumber: 1,
        quantity: 100,
      },
    });

    if (res?.data?.status?.codigoRetorno === 0) {
      yield put(
        setCustomer({
          recharges: {
            ...customer?.recharges,
            lastUpdated: new Date(),
          },
        }),
      );
      const movimentations = Object.values(res?.data?.data).flatMap(
        (item) => item?.movimentations,
      );
      yield call(payload.callback, true, movimentations);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
